import { dateFrEn, error, success } from "@global/actions";
import { apiSend, getRoute } from "@services/axios";
import FormPrice from "./forms/FormPrice";
import { confirm } from "@global/actions";
export const loadPrice = async (id, dateFrom, dateTo) => {
  window.loader(1);
  const payload = {
    dateFrom: dateFrEn(dateFrom),
    dateTo: dateFrEn(dateTo),
  };
  const response = await apiSend(
    [getRoute("PRODUCT_RETRIEVE"), id, "pricing"].join("/"),
    "post",
    payload
  );
  window.loader(0);
  return response?.data?.result;
};

export const loadPromos = async (id, dateFrom, dateTo) => {
  window.loader(1);
  const payload = {
    dateFrom: dateFrEn(dateFrom),
    dateTo: dateFrEn(dateTo),
  };
  const response = await apiSend(
    [getRoute("PRODUCT_RETRIEVE"), id, "promotions"].join("/"),
    "post",
    payload
  );
  window.loader(0);

  return response?.data?.result;
};

export const saveStopSales = async (id, tarif) => {
  var is_stop_sales = 1 - parseInt(tarif.is_stop_sales);
  const payload = {
    is_stop_sales: is_stop_sales,
  };

  try {
    const res = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        id,
        "pricing",
        tarif.id,
        "stop",
        "sales",
      ].join("/"),
      "post",
      payload
    );

    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      is_stop_sales = 1 - parseInt(is_stop_sales);
      error(res?.data?.result?.message);
    }
    return is_stop_sales;
  } catch (error) {
    console.error("❌ Error updating tarif:", error);
  }
};

export const savePrice = async (service, id, tarifId, payload) => {
  var bool = true;
  try {
    const res = await apiSend(
      [getRoute("PRODUCT_RETRIEVE"), id, "pricing", tarifId, "service"].join(
        "/"
      ),
      "post",
      payload
    );

    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      error(res?.data?.result?.message);
      bool = false;
    }
    return bool;
  } catch (error) {
    console.error("❌ Error updating tarif:", error);
  }
};

export const createOrUpdatePromotion = async (id, payload, promoId = 0) => {
  var bool = true;
  var url = [getRoute("PRODUCT_RETRIEVE"), id, "promotions"];

  if (promoId === 0) {
    url.push("create");
  } else {
    url.push(promoId);
    url.push("update");
  }

  try {
    const res = await apiSend(url.join("/"), "post", payload);
    console.log(res);
    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      if (res?.data?.result?.message) {
        error(res?.data?.result?.message);
      } else {
        if (typeof res?.data?.result?.Error === "object") {
          if (res?.data?.result?.Error?.name) {
            error(res?.data?.result?.Error?.name);
          } else {
            error("update error");
          }
        } else {
          error(res?.data?.result?.Error);
        }
      }

      bool = false;
    }
    return bool;
  } catch (error) {
    console.error("❌ Error updating tarif:", error);
  }
};

/**
 * Save or update a single info item for a product
 * @param {number|string} productId - The ID of the product
 * @param {string} model - The model name (e.g. included, excluded, requiredItems)
 * @param {number|string} modelId - The specific item ID in that model
 * @param {string} value - The updated value to save
 */
export const saveInfoItem = async (productId, model, modelId, value) => {
  try {
    const url = `product/${productId}/infos/${model}/${modelId}`;
    const body = { value };

    const res = await apiSend(url, "post", body);

    if (res?.data?.status === 200 || res?.data?.status === 201) {
      console.log(`✅ Saved ${model} item successfully:`, res.data);
    } else {
      console.warn(`⚠️ Failed to save ${model} item:`, res);
    }
    console.log(res);
    return res;
  } catch (error) {
    console.error(`❌ Error saving ${model} item:`, error);
    throw error;
  }
};

export const addInfoItem = async (productId, model, value) => {
  try {
    const url = `product/${productId}/infos/${model}`;
    const body = { value };

    const res = await apiSend(url, "post", body);

    if (res?.status === 200 || res?.status === 201) {
      console.log(`✅ Added ${model} item successfully:`, res.data);
    } else {
      console.warn(`⚠️ Failed to add ${model} item:`, res);
    }
    return res;
  } catch (error) {
    console.error(`❌ Error adding ${model} item:`, error);
    throw error;
  }
};

/**
 * Save or update a single info item for a product
 * @param {number|string} productId - The ID of the product
 * @param {string} model - The model name (e.g. included, excluded, requiredItems)
 * @param {object} itemUpdate - The updated item to save
 * @param {object} itemNew - The add item to save
 */
export const saveMultiInfoItem = async (
  productId,
  model,
  itemUpdate,
  itemNew
) => {
  try {
    const url = `product/${productId}/infos/${model}/multisave`;
    const body = { itemUpdate: itemUpdate, itemNew: itemNew };
    const res = await apiSend(url, "post", body);

    console.log(res);

    if (res?.data?.status === 200 || res?.data?.status === 201) {
      console.log(`✅ Saved ${model} item successfully:`, res.data);
    } else {
      console.warn(`⚠️ Failed to save ${model} item:`, res);
    }
    console.log(res);
    return res;
  } catch (error) {
    console.error(`❌ Error saving ${model} item:`, error);
    throw error;
  }
};

export const saveChangeStatusPromo = async (id, promoId, status) => {
  var bool = true;

  const payload = {
    status: status,
  };

  try {
    const res = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        id,
        "promotions",
        "activate",
        promoId,
      ].join("/"),
      "post",
      payload
    );
    console.log(res);
    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      if (res?.data?.result?.Error?.status) {
        error(res?.data?.result?.Error?.status);
      } else {
        error("update error");
      }
      bool = false;
    }
    return bool;
  } catch (error) {}
};

export const getEarn = (price, charge_service, charge_service_type) => {
  const service = (price * charge_service) / 100;
  if (charge_service_type === "in") {
    price = price - service;
  }
  return price.toFixed(2);
};
export const getCharge = (price, charge_service) => {
  const service = (price * charge_service) / 100;
  return service.toFixed(2);
};

export const getTravelerPrice = (
  price,
  charge_service,
  charge_service_type
) => {
  const service = (price * charge_service) / 100;
  if (charge_service_type === "out") {
    price = price + service;
  }
  return price.toFixed(2);
};

export const saveChangeTypePriceRoom = async (
  id,
  roomId,
  room_pricing_type
) => {
  var bool = true;

  const payload = {
    room_pricing_type: room_pricing_type,
  };
  try {
    const res = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        id,
        "rooms",
        roomId,
        "change/price/type",
      ].join("/"),
      "post",
      payload
    );

    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      error(res?.data?.result?.message, "error");
      bool = false;
    }

    return bool;
  } catch (error) {}
};

export const saveChangeStatusRoom = async (id, roomId, status) => {
  var bool = true;

  const payload = {
    status: status,
  };
  try {
    const res = await apiSend(
      [getRoute("PRODUCT_RETRIEVE"), id, "rooms", roomId, "change/status"].join(
        "/"
      ),
      "post",
      payload
    );

    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      error(res?.data?.result?.message, "error");
      bool = false;
    }

    return bool;
  } catch (error) {}
};

export const saveChangeRoomStatusAndAvailability = async (id, payload) => {
  var bool = true;

  try {
    const res = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        id,
        "rooms",
        "change/status/and/availability",
      ].join("/"),
      "post",
      payload
    );

    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      error(res?.data?.result?.message, "error");
      bool = false;
    }

    return bool;
  } catch (error) {}
};

export const loadStopSale = (tarif, paramUseModal, changeStopSales, t) => {
  confirm({
    useModal: paramUseModal,
    title: tarif.item.date,
    params: tarif,
    messageConfirm: tarif.item.is_stop_sales
      ? t("activate_sales_confirm")
      : t("deactivate_sales_confirm"),
    handleChange: changeStopSales,
  });
};

export const loadPriceForms = (
  tarif,
  paramUseModal,
  t,
  changePrice,
  service
) => {
  paramUseModal.setSize("md");
  paramUseModal.setTitle(t("price") + " : " + tarif.item.date);
  paramUseModal.openModal(
    <FormPrice
      tarif={tarif}
      t={t}
      closeModal={paramUseModal.closeModal}
      changePrice={changePrice}
      service={service}
    />
  );
};
